import { RolesManagement } from '../components/roles-management';
import { UsersManagement } from '../components/users-management';

export function UserManagementPage() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-6 px-2 py-4 sm:px-4 lg:px-6">
      <UsersManagement />

      {/* Divider */}
      <div className="border-t border-gray-200"></div>

      <RolesManagement />
    </div>
  );
}
